@let bonusTimeLeft = bonusTimeLeft$ | async;
@let daysLeft = daysLeft$ | async;
@let depositBonusExpirationDate = (depositBonusExpirationDate$ | async) || '';
@let depositBonusAvailability = depositBonusAvailability$ | async;

<ng-container *ngrxLet="state$; let state">
  @switch (state) {
    @case ('loading') {
      <ng-container *ngTemplateOutlet="select" />
      <app-loader containerHeight="100px" [isInner]="true" [small]="true" />
    }
    @case ('noTrade') {
      <pac-alert
        description="account-analytics.alert.no-trade"
        type="info"
      />
      <ng-container *ngTemplateOutlet="table" />
    }
    @case ('success') {
      <ng-container *ngTemplateOutlet="select" />
      <ng-container *ngTemplateOutlet="table" />
    }
    @case ('failed') {
      <pac-retry-block-scoped (retry)="loadAnalytics()" />
    }
  }
</ng-container>

<ng-template #select>
  <div class="custom-select-new">
    <ng-select
      [clearable]="false"
      [formControl]="periodControl"
      [items]="periods"
      [searchable]="false"
      >
      <ng-template let-item="item" ng-label-tmp ng-option-tmp>
        {{ item.title | translate:{ days: item.daysReplacement } }}
      </ng-template>
    </ng-select>
  </div>
</ng-template>

<ng-template #table>
  <ul class="params" [class.params--expanded]="(!account.isDemo && depositBonusAvailability?.bonusIsAvailable) || account.credit > 0">
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.closed-orders"></span>
      <span class="params__value">{{ analytics.closedOrders | number: '1.0-0':language }}</span>
    </li>
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.lots"></span>
      <span class="params__value">{{ analytics.lots | number: '1.2-2':language }}</span>
    </li>
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.volume"></span>
      <span class="params__value" dir="ltr">
        {{ analytics.tradingVolume | currency:
        (account.currency | fixRateCurrencyConverter) :'symbol':'1.2-2': language }}
      </span>
    </li>
    @if ((!account.isDemo && depositBonusAvailability?.bonusIsAvailable) || depositBonusAvailability?.wasReceived) {
      <li class="params__item params__item--combined" >
        <div class="params__item">
          <span class="params__title" translate="deposit-bonus.bonus"></span>
          <span
            class="params__value"
            [ngClass]="{
              'params__value--red': ['medium', 'short', 'imminent'].includes(bonusTimeLeft) && account.credit > 0 && !hasDatePassed(depositBonusExpirationDate),
              'params__value--orange': bonusTimeLeft === 'long' && account.credit > 0 && !hasDatePassed(depositBonusExpirationDate)}"
          >
            {{ account.credit | money | currency: (account.currency | fixRateCurrencyConverter) }}
          </span>
        </div>

        @if (account.credit > 0 && depositBonusExpirationDate.length > 0 && !hasDatePassed(depositBonusExpirationDate)) {
          @switch (bonusTimeLeft) {
            @case ('imminent') {
              <span
                class="bonus-expiration bonus-expiration--red"
                translate="deposit-bonus.active-until.imminent"
                [translateParams]="{ date: depositBonusExpirationDate | date: 'HH:mm' }">
              </span>
            }
            @case ('short') {
              <span
                class="bonus-expiration bonus-expiration--red"
                translate="deposit-bonus.active-until.short">
              </span>
            }
            @case ('medium') {
              <span
                class="bonus-expiration bonus-expiration--red"
                translate="deposit-bonus.active-until.medium"
                [translateParams]="{ days: daysLeft }">
              </span>
            }
            @case ('long') {
              <span
                class="bonus-expiration bonus-expiration--orange"
                translate="deposit-bonus.active-until.medium"
                [translateParams]="{ days: daysLeft }">
              </span>
            }
            @default {
              <span
                class="bonus-expiration"
                translate="deposit-bonus.active-until.default"
                [translateParams]="{ date: depositBonusExpirationDate | date: 'MMMM dd, HH:mm' }">
              </span>
            }
          }
        }
      </li>
    }
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.profit"></span>
      <span class="params__value" dir="ltr">
        {{ analytics.profit | currency:
        (account.currency | fixRateCurrencyConverter) :'symbol':'1.2-2': language }}
      </span>
    </li>
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.loss"></span>
      <span class="params__value" [ngClass]="{'params__value--loss': analytics.loss !== 0}">
        <span dir="ltr">{{ -analytics.loss | currency:
        (account.currency | fixRateCurrencyConverter) :'symbol':'1.2-2': language }}</span>
      </span>
    </li>
    <li class="params__item">
      <span class="params__title" translate="account-analytics.label.net-profit"></span>
      <span class="params__value total">
        @if (analytics.netProfitFraction !== 0) {
          <span
            [ngClass]="{'positive': analytics.netProfitFraction > 0,'negative': analytics.netProfitFraction < 0}"
            >
            {{analytics.netProfitFraction | percent:'1.2-2':language}}
          </span>
        }
        <span dir="ltr">
          {{analytics.netProfit | currency: (account.currency | fixRateCurrencyConverter) :'symbol':'1.0-2': language}}
        </span>
      </span>
    </li>
  </ul>
</ng-template>
